import React from 'react';

const CallCenter: React.FC = () => {
    return (
            <>
            <div className="help mt20 mobile">
                <ul className="li_common">
                    <li>
                        더 자세한 상담을 진행하고 싶으시면 헬스콜센터로 연락주세요.
                        <p className="lh24"><span className="green">교보헬스콜센터</span> 
                        <a href="tel:1588-7524">1588-7524</a>
                        <span className="br"></span>(평일 : 09:00~19:00 / 토요일 : 09:00~13:00)</p>
                    </li>
                </ul>
            </div>
            <div className="help mt20 pc">
                <ul className="li_common">
                    <li>
                        더 자세한 상담을 진행하고 싶으시면 헬스콜센터로 연락주세요.
                        <p className="lh24"><span className="green">교보헬스콜센터</span> 
                        <a href="#">1588-7524</a>
                        <span className="br"></span>(평일 : 09:00~19:00 / 토요일 : 09:00~13:00)</p>
                    </li>
                </ul>
            </div>
            <div className="help mt20 tablet">
                <ul className="li_common">
                    <li>
                        더 자세한 상담을 진행하고 싶으시면 헬스콜센터로 연락주세요.
                        <p className="lh24"><span className="green">교보헬스콜센터</span> 
                        <a href="#">1588-7524</a>
                        <span className="br"></span>(평일 : 09:00~19:00 / 토요일 : 09:00~13:00)</p>
                    </li>
                </ul>
            </div>
            <div className="banner">
                <p className="black lh34 f16">'힐링컨텐츠' 보고 마음 치유하세요~ </p>
                <a href="#" className="m blue">보러가기</a>
            </div>
            <div className="center mt20">
                <a href="/psychlgclCheck/main" className="m white">목록으로</a>
            </div>
        </>
    )
}

export default CallCenter;